import React from "react";
import OptionList from "./OptionList";

export default function CareersContainer() {
  return (
      <OptionList />
  );
};

